import type { IWidgetSDK } from '../core'

export function getCurrentWidgetSDK(): IWidgetSDK | null {
  return globalThis.window?.getCurrentWidgetSDK?.() ?? null
}
